<template lang="pug">
    multiselect-form(
        ref="modifierSetForm"
        :value="value",
        name="modifierSet",
        :options="filteredModifierSetList",
        :fixed-items="fixedItems"
        placeholder="Type to search or create modifier",
        item-placeholder="Add this as new modifier",
        @create="submit",
        @add-item="addItem",
        @show-form="onShowForm",
        @hide-form="onHideForm",
        @input="onInput",
        title="Modifiers",
        form-title="Create New Modifiers"
    )
        template(slot="body")
            form(id="modifierSetForm")
                div.row
                    div.col-xs-12
                        div.md-form-group
                            input.md-input(
                                type="text",
                                :value="modifierSet.name",
                                id="modifierSetName",
                                @input="updateModiferSet('name', $event)",
                                :disabled="onCreateLoading",
                                required
                            )
                            label Name

                div.row
                    div.col-xs-6
                        div.md-form-group
                            input.md-input(
                                type="number",
                                :value="modifierSet.min_apply_limit",
                                @input="updateModiferSet('min_apply_limit', $event)",
                                :disabled="onCreateLoading",
                                required
                            )
                            label Min Apply Limit
                    div.col-xs-6
                        div.md-form-group
                            input.md-input(
                                type="number",
                                :value="modifierSet.max_apply_limit",
                                @input="updateModiferSet('max_apply_limit', $event)",
                                :disabled="onCreateLoading",
                                required
                            )
                            label Max Apply Limit

                div.row
                    div.col-xs-12.m-b-sm
                        span._500 Modifiers

                div.row(v-for="(modifier, idx) in modifierSet.modifiers")
                    div.col-xs-4
                        div.md-form-group
                            select.md-input(
                                :value="modifier.mode", 
                                @input="updateModiferSet('modifiers', $event, 'mode', idx)",
                                :disabled="onCreateLoading",
                                required
                            )
                                option(v-for="mode in modes", v-bind:value="mode.id") {{ mode.name }}
                            label Mode
                    div.col-xs-4
                        div.md-form-group
                            input.md-input(
                                type="text",
                                :value="modifier.name",
                                @input="updateModiferSet('modifiers', $event, 'name', idx)",
                                :disabled="onCreateLoading",
                                required
                            )
                            label Name
                    div.col-xs-3
                        div.md-form-group
                            input.md-input(
                                type="text",
                                data-parsley-type="number",
                                :value="modifier.amount",
                                @input="updateModiferSet('modifiers', $event, 'amount', idx)",
                                :disabled="onCreateLoading",
                                required
                            )
                            label Amount

                    div.col-xs-1(v-if="modifierSet.modifiers.length > 1")
                        i.text-muted.material-icons.md-18.btn-del-list.pointer(
                            @click="removeModifier(idx)"
                        ) &#xe14c;

                div.row
                    div.col-xs-12.text-right
                        button.btn.btn-sm.btn-default(
                            type="button",
                            @click="addModifier",
                            :disabled="onCreateLoading"
                        ) Add Modifier
</template>

<script>
import multiselectForm from './multiselect-form.vue';
import { mapGetters, mapActions } from 'vuex';

export default {
    components: { multiselectForm },

    props: {
        value: {
            type: Array,
            required: true,
        },

        tagModifiers: {
            type: Array,
            required: false,
            default: () => [],
        },
    },

    computed: {
        ...mapGetters('modifierSet', [
            'modifierSetList',
            'modifierSet',
            'modes',
        ]),

        filteredModifierSetList() {
            return this.modifierSetList.filter(s => {
                return !this.tagModifiers.find(e => e.id === s.id);
            });
        },

        fixedItems() {
            return this.tagModifiers.map(m => m.name);
        },

        onCreateLoading() {
            return this.onLoading('create item');
        },
    },

    mounted() {
        this.getModifierSetList();
        this.registerEvent();
    },

    methods: {
        ...mapActions('modifierSet', [
            'getModifierSetList',
            'setModifierSetAttribute',
            'addModifier',
            'removeModifier',
            'createModifierSet',
            'addModifierSet',
            'resetModifierSet',
        ]),

        submit() {
            if (!this.validateForm('modifierSetForm')) return;

            this.startLoading('create item');

            this.createModifierSet()
                .then(res => {
                    let item = res.data.data;
                    this.$emit('item-created', item);
                })
                .catch(err => {
                    this.showApiError(err);
                    this.endLoading('create item');
                });
        },

        updateModiferSet(
            attribute,
            event,
            modifier_attr = null,
            modifier_index = null,
        ) {
            let input = {
                attribute,
                value: event.target.value,
                modifier_attr,
                modifier_index,
            };

            this.setModifierSetAttribute(input);
        },

        addItem(item) {
            this.setModifierSetAttribute({ attribute: 'name', value: item });
        },

        focusOnForm() {
            setTimeout(() => {
                document.getElementById('modifierSetName').focus();
            }, 100);
        },

        onShowForm() {
            this.focusOnForm();
        },

        onHideForm() {
            this.resetModifierSet();
        },

        registerEvent() {
            this.$on('item-created', item => {
                this.addModifierSet(item);
                this.$refs.modifierSetForm.$emit('item-created', item);
            });
        },

        onInput(value) {
            this.$emit('input', value);
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/inventory/item/modifier-selector.vue